import axios from 'axios';

export const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bw_erfassung_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      localStorage.removeItem('bw_erfassung_token');
      localStorage.removeItem('bw_erfassung_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }).then((r) => r.data),
  setup: (email: string, password: string, name: string) =>
    api.post('/auth/setup', { email, password, name }).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  setupStatus: () => api.get('/auth/setup-status').then((r) => r.data),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post('/auth/change-password', { currentPassword, newPassword }).then((r) => r.data),
};

export const usersAPI = {
  list:   () => api.get('/users').then((r) => r.data),
  create: (data: { email: string; password: string; name: string; role?: string }) =>
    api.post('/users', data).then((r) => r.data),
  update: (id: string, data: any) => api.put(`/users/${id}`, data).then((r) => r.data),
  resetPassword: (id: string, newPassword: string) =>
    api.put(`/users/${id}/password`, { newPassword }).then((r) => r.data),
  delete: (id: string) => api.delete(`/users/${id}`).then((r) => r.data),
};

export const projekteAPI = {
  list:   () => api.get('/projekte').then((r) => r.data),
  get:    (id: string) => api.get(`/projekte/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/projekte', data).then((r) => r.data),
  update: (id: string, data: any) => api.put(`/projekte/${id}`, data).then((r) => r.data),
};

export const baeumeAPI = {
  list:   (projektId: string) => api.get(`/baeume?projekt_id=${projektId}`).then((r) => r.data),
  get:    (id: string) => api.get(`/baeume/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/baeume', data).then((r) => r.data),
  update: (id: string, data: any) => api.put(`/baeume/${id}`, data).then((r) => r.data),
  delete: (id: string) => api.delete(`/baeume/${id}`).then((r) => r.data),
  nextNummer: (projektId: string) =>
    api.get(`/baeume/projekt/${projektId}/next-nummer`).then((r) => r.data),
};

export const schadenAPI = {
  create: (data: any) => api.post('/schaden', data).then((r) => r.data),
  update: (id: string, data: any) => api.put(`/schaden/${id}`, data).then((r) => r.data),
  delete: (id: string) => api.delete(`/schaden/${id}`).then((r) => r.data),
};

export const presetsAPI = {
  list:   (projektId?: string) =>
    api.get(`/presets${projektId ? `?projekt_id=${projektId}` : ''}`).then((r) => r.data),
  create: (data: any) => api.post('/presets', data).then((r) => r.data),
  delete: (id: string) => api.delete(`/presets/${id}`).then((r) => r.data),
};

export const exportAPI = {
  csvUrl: (projektId: string) => `/api/export/projekt/${projektId}/csv`,
};
